module.exports = __webpack_public_path__ + "2b8e5fa906abb862cb504cce3c500dc5.png";